<template>
  <div>
    <el-dialog v-model="dialogStatus" :close-on-click-modal="false" :title="title" @close="close" width="50%"
      append-to-body>
      <el-form :model="form" ref="form" :rules="rules" label-position="left" label-width="100px">
        <el-form-item v-if="title !== '修改用户信息编辑'" label="账号" prop="account">

          <el-input v-model="form.account"></el-input>
        </el-form-item>
        <el-form-item v-if="title !== '修改用户信息编辑'" label="用户名" prop="accountName">
          <el-input v-model="form.accountName"></el-input>
        </el-form-item>
        <el-form-item v-if="title !== '修改用户信息编辑'" label="邮箱" prop="mailbox">
          <el-input v-model="form.mailbox"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleIdList">
          <el-radio-group v-model="form.roleIdList">
            <el-radio v-for="(item, index) in roleIdList" :label="item.roleId">{{ item.roleName }}</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>

      <div>
        <div>拥有权限：</div>
        <el-tree :data="treeData" :props="defaultProps" default-expand-all>
        </el-tree>
      </div>

      <div style="text-align: right">
        <el-button @click="close" size="medium">取消</el-button>
        <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  sysUserRoleList,
  sysUserRoleMenuList,
  addAdmin,
  updateAdmin
} from "@/api/jurisdiction/administrator/index";

const form = {
  account: undefined,
  accountName: undefined,
  mailbox: undefined,
  password: undefined,
  roleIdList: undefined
};
export default {
  props: {
    title: String
  },
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        accountName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        roleIdList: [{ required: true, message: "请选择角色", trigger: "blur" }],
      },
      dynamicTags: undefined,
      inputVisible: false,
      inputValue: "",
      dspSlotData: undefined,
      dspData: undefined,
      brandData: undefined,
      model: [],
      header: {},
      checkAll: false,
      roleIdList: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      }
    };
  },
  created() { },
  mounted() { },
  watch: {
    "form.roleIdList": {
      handler(newVal) {
        if (newVal) {
          sysUserRoleMenuList({ roleId: newVal }).then(res => {
            this.treeData = res.data
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {},
  emits: ['submit'],
  methods: {
    async show(data) {
      let roleIdList = await sysUserRoleList()
      this.roleIdList = roleIdList.data
      if (data) {
        this.form = Object.assign({}, data);
        roleIdList.data.forEach(index => {
          if (index.roleName == this.form.roleName) {
            this.form.roleIdList = index.roleId
          }
        })
      }
      this.dialogStatus = true;
    },
    close() {
      this.reset();
      this.dialogStatus = false;
    },
    reset() {
      this.form = Object.assign({}, form);
      this.treeData = []
      this.$refs.form.resetFields();
    },
    // onChange(val) {
    //   sysUserRoleMenuList({ roleId: val }).then(res => {
    //     this.treeData = res.data
    //   })
    // },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.roleIdList = [this.form.roleIdList]
          if (this.title === '修改用户信息编辑') {
            this.updateAdmin(this.form);
          } else {
            this.addAdmin(this.form)
          }
        }
      });
    },
    addAdmin(form) {
      this.submitLoading = true;
      addAdmin(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("新增成功");
            this.$emit("submit");
            this.close();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    updateAdmin(form) {
      this.submitLoading = true;
      updateAdmin(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.$emit("submit");
            this.close();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },

    selectData() {
      let dsp = { dspId: this.form.dspId };
      selectData(dsp).then((res) => {
        if (res.code === 200) {
          this.dspSlotData = res.data;
        }
      });
    },
    onSuccess(res) {
      if (res.code === 200) {
        this.form.testUrl = res.data[0] || ''
      }
    },
    showInput() {
      this.inputVisible = true;
      // this.$nextTick((_) => {
      //   this.$refs.saveTagInput.$refs.input.focus();
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
  text-align: center;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

// /deep/ .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
// }
// /deep/ .el-upload:hover {
//   border-color: #409eff;
// }
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>